<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{ data.sysText.sendInvitation_header }}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" mat-dialog-close [aria-label]="(data.inviteDialog.isEmployerAccessAllowed && !data.inviteDialog.isEmployeeInactive) ? data.sysText.cancel : data.sysText.close" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
  <mat-divider class="section-header-underline"></mat-divider>
</div>

<mat-dialog-content>
  @if (data.inviteDialog.email == null) {
    <p class="body2 bottom-margin">{{data.sysText.sendInvitation_noEmail}}</p>
  } @else if (!data.inviteDialog.isEmployerAccessAllowed) {
    <p class="body2 bottom-margin">{{data.sysText.sendInvitation_noAccess}}</p>
  } @else if (data.inviteDialog.isEmployeeInactive) {
    <p class="body2 bottom-margin">{{data.sysText.sendInvitation_inactive}}</p>
  } @else {
    <p class="body2">{{data.sysText.sendInvitation_body1}}</p>
    <p class="body2 email">{{data.inviteDialog.email}}</p>
    <p class="body2 bottom-margin">{{data.sysText.sendInvitation_body2}}</p>
    @if (data.inviteDialog.isUserActivated) {
      <p class="body2 bottom-margin">{{data.sysText.sendInvitation_body3}}</p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      mat-dialog-close
      [disabled]="isSubmitting">
      {{ (data.inviteDialog.isEmployerAccessAllowed && !data.inviteDialog.isEmployeeInactive) ? data.sysText.cancel : data.sysText.close}}
    </button>
  }
  @if (data.inviteDialog.isEmployerAccessAllowed && !data.inviteDialog.isEmployeeInactive && data.inviteDialog.email != null) {
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && save()">
      {{ data.sysText.sendInvite }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>

